import { api } from "lib/graphql/api"
import { gql } from "@apollo/client"
import { query } from "lib/graphql/query"

export const getMissingRequiredDraftAmends = api(async function getMissingRequiredDraftAmends({
    projectId,
    scheduleId,
}) {
    if (!projectId || !scheduleId) return []
    return query(
        gql`
            query GetMissingRequiredDraftAmends($projectId: String!, $scheduleId: String!) {
                getMissingRequiredDraftAmends(projectId: $projectId, scheduleId: $scheduleId)
            }
        `,
        { projectId, scheduleId },
        {
            returns: "getMissingRequiredDraftAmends",
            fetchPolicy: "network-only",
        }
    )
})
